import script from "./BusinessServiceVendorEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessServiceVendorEditor.vue?vue&type=script&setup=true&lang=js"

import "./BusinessServiceVendorEditor.vue?vue&type=style&index=0&id=545dfa92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545dfa92"]])

export default __exports__